'use client'

import { useFieldValue, useForm } from 'form-atoms'
import { useCallback } from 'react'
import { TokenSelector } from '@/src/components/form/token-selector'
import { swapFormAtom } from '@/src/stores/swap/atoms'
import { useTokenSelection } from '@/src/stores/token-selection/actions'
import { AmountOutLabel } from './amount-out-label'

export const ToSection = () => {
  const { fieldAtoms } = useForm(swapFormAtom)
  const toTokenValue = useFieldValue(fieldAtoms.to)
  const { open: openTokenSelection } = useTokenSelection()

  /**
   * If from token value is not set we would like to open token selection,
   * if they press amount input or other place inside from section
   */
  const onClick = useCallback(() => {
    if (toTokenValue?.chain) return

    openTokenSelection('to')
  }, [toTokenValue, openTokenSelection])

  return (
    <div
      className='flex items-center gap-3 py-2 px-2 justify-between min-h-24'
      onMouseDown={onClick}
    >
      <AmountOutLabel />
      <TokenSelector direction='to' />
    </div>
  )
}
